import React from 'react';

function PageNotFound() {
  return (
    <div>
    <center>
      <h2>404 Page not found</h2>
      <p>Sorry, the page you are looking for is currently unavailable.<br/>
      Please try after sometime.</p>
    </center>
    </div>
  );
}

export default PageNotFound;